module.exports = __webpack_public_path__ + "static/profile.b2a1f82f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/biography/profile.jpg
// module id = 57
// module chunks = 168707334958949